
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Tag } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

interface CouponSectionProps {
  form: UseFormReturn<z.infer<any>>;
  applyCoupon: boolean;
  setApplyCoupon: React.Dispatch<React.SetStateAction<boolean>>;
}

const CouponSection: React.FC<CouponSectionProps> = ({
  form,
  applyCoupon,
  setApplyCoupon,
}) => {
  return (
    <>
      <div className="flex items-center gap-2">
        <Switch 
          id="enableCoupon" 
          checked={applyCoupon}
          onCheckedChange={setApplyCoupon}
        />
        <label htmlFor="enableCoupon" className="font-medium cursor-pointer flex items-center gap-1">
          <Tag className="h-4 w-4" />
          Add coupon code for this product
        </label>
      </div>
      
      {applyCoupon && (
        <FormField
          control={form.control}
          name="couponCode"
          render={({ field }) => (
            <FormItem className="pl-6 border-l-2 border-gray-200">
              <FormLabel>Coupon Code</FormLabel>
              <FormControl>
                <Input 
                  placeholder="e.g., SUMMER20" 
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};

export default CouponSection;
